import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import Const from 'constants';
import Tooltip from 'components/atoms/tooltip';
import {interpret} from 'dictionary';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class ExposureMode extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('ExposureMode', value));
    }

    getOptions() {
        const {sportConfig} = this.props;

        const options = {[Const.EXPOSURE_MODE_OPTIMAL]: 'Optimal mode'};

        if (!sportConfig.isModeLateswap()) {
            options[Const.EXPOSURE_MODE_TOURNAMENT] = interpret('Tournament mode');
        }

        return options;
    }

    render() {
        const {exposureMode} = this.props;

        const options = this.getOptions();
        const selectedExposureMode = exposureMode.getExposureMode();

        return (
            <div className="input-info">
                <Tooltip
                    subject={`Optimal Mode - This is ideal for cash games or mass multi entry when you are not using the min/max exposure settings. Each lineup produced will look for the highest possible fantasy points totals.
                                ${interpret('Tournament mode')} - Specifically for use in mass-multi entry, it is designed to more evenly distribute players when min/max exposure settings are employed. High projected pts/$ value players with max exposure limitations will be more evenly distributed throughout the entire run of lineups.`}
                />
                <SimpleSelect
                    key={selectedExposureMode}
                    value={selectedExposureMode}
                    options={options}
                    onChange={::this.onChange}
                    testId="optimization-mode-dropdown"
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {exposureMode, sportConfig} = state;

    return {
        exposureMode,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(ExposureMode);
